var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.index === _vm.imgind)?_c('div',{staticClass:"expandable-image",class:{
      expanded: _vm.expanded,
    }},[_c('div',{staticClass:"container"},[_c('video',{attrs:{"height":_vm.imageDimension.height,"width":"100%","src":_vm.src,"controls":""}}),(_vm.expanded)?_c('i',{staticClass:"close-button"},[_c('img',{attrs:{"src":require("@/assets/cross.svg"),"alt":"ZoomOut"}})]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }